import { NetNotice } from "@/constants/netEvent";
import { reqPost } from "@/service/clientRequest";
import {
  GetMsgInfoReq,
  GetMsgInfoRsp,
  GetMsgListReq,
  GetMsgListRsp,
  GetUnreadReq,
  GetUnreadRsp,
  ReadMsgAllReq,
  ReadMsgReq,
} from "@/types/swagger/notice";

export async function GetUnread(data: GetUnreadReq) {
  // return await Apis.notice.GetUnread({
  //   params: {},
  //   data,
  //   method: "POST",
  // });
  return reqPost<GetUnreadReq, GetUnreadRsp>(
    data,
    NetNotice.mod,
    NetNotice.GetUnread,
    true,
  );
}
export async function GetMsgInfo(data: GetMsgInfoReq) {
  return reqPost<GetMsgInfoReq, GetMsgInfoRsp>(
    data,
    NetNotice.mod,
    NetNotice.GetMsgInfo,
    true,
  );
}

export async function GetUnreadMsg(data: GetMsgListReq) {
  return reqPost<GetMsgListReq, GetMsgListRsp>(
    data,
    NetNotice.mod,
    NetNotice.GetMsgList,
    true,
  );
}

export async function ReadMsg(data: ReadMsgReq) {
  return reqPost<ReadMsgReq, {}>(data, NetNotice.mod, NetNotice.ReadMsg, true);
}

export async function ReadAllMsg(data: ReadMsgAllReq) {
  return reqPost<ReadMsgAllReq, {}>(
    data,
    NetNotice.mod,
    NetNotice.ReadAllMsg,
    true,
  );
}
